export default function() {
    jQuery('.js-aditional-info').on('click', function(ev) {
        ev.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery(this).next('.image-text__aditional-info').slideToggle(300);
    });
}